import {
  FETCH_CARRIER_PAYABLES_MASTERDATA,
  FETCH_CARRIER_PAYABLES_MASTERDATA_LOADING,
  FETCH_CARRIER_PAYABLES_MASTERDATA_ERROR,
} from '../actions/constants';

const defaultState = {
  loading: false,
  payoutData: null,
  error: null,
  isFetched: false,
};

export default function carrierPayablesMasterDataReducer(
  state = defaultState,
  action,
) {
  switch (action.type) {
    case FETCH_CARRIER_PAYABLES_MASTERDATA_LOADING:
      return {
        ...state,
        loading: true,
      };

    case FETCH_CARRIER_PAYABLES_MASTERDATA:
      return {
        ...state,
        loading: false,
        payoutData: action.data,
        error: null,
        isFetched: true,
      };

    case FETCH_CARRIER_PAYABLES_MASTERDATA_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
}
